import { module } from 'modujs';
import LocomotiveScroll from 'locomotive-scroll';
import { lazyLoadImage } from '../utils/image';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.scroll = new LocomotiveScroll({
            el: this.el,
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true
        });

        this.scroll.on('call', (func, way, obj, id) => {
            // Using modularJS
            this.call(func[0], { way, obj }, func[1], func[2]);
        });

        this.scroll.on('scroll', (args) => {
            if(args.direction != this.currentDirection) {
                html.setAttribute('data-scroll-direction', args.direction)
                this.currentDirection = args.direction;
            }

            if(args.scroll.y > 80) {
                html.classList.add('has-scrolled')
            } else {
                html.classList.remove('has-scrolled')
            }

            // for(let element of Array.from(args.currentElements)) {
            for (const [key, element] of Object.entries(args.currentElements)) {
                if(element.el.getAttribute('data-module-project-list-item') != null) {
                    this.call('update', element, 'ProjectListItem')
                }
            }

            // Marquee scroll speed acceleration
            if (typeof args.currentElements['marquee'] === 'object') {
                let scrollSpeed = args.speed
                this.call('onScrolling', scrollSpeed, 'Marquee');
            }

            if(args.currentElements['project-head-sticky']) {
                this.call('onScroll', args.currentElements['project-head-sticky'].progress, 'ProjectHead')
            }
        })

        this.scroll.scrollTo(0, { duration: 0, disableLerp: true })
    }

    /**
     * Lazy load the related image.
     *
     * @see ../utils/image.js
     *
     * It is recommended to wrap your `<img>` into an element with the
     * CSS class name `.c-lazy`. The CSS class name modifier `.-lazy-loaded`
     * will be applied on both the image and the parent wrapper.
     *
     * ```html
     * <div class="c-lazy o-ratio u-4:3">
     *     <img data-scroll data-scroll-call="lazyLoad, Scroll, main" data-src="http://picsum.photos/640/480?v=1" alt="" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" />
     * </div>
     * ```
     *
     * @param {LocomotiveScroll} args - The Locomotive Scroll instance.
     */
    lazyLoad(args) {
       lazyLoadImage(args.obj.el, null, () => {
           //callback
       })
    }

    update() {
        this.scroll.update();
    }

    scrollTo(params) {
        if(this.scroll && this.scroll.scrollTo) this.scroll.scrollTo(params.target, params.options);
    }

    destroy() {
        this.scroll.destroy();
    }
}

// export scrollSpeed as scrollSpeed;
